module.exports = __webpack_public_path__ + "static/img/khk002a-block.6fc7456e.png";